<template>
     <div class="table_nav">
         <div class="table_name">
            <span>
                {{title}}
            </span>
            <span :style="{color:this.itemColor ? this.itemColor : '#222'}">
                {{item}}
            </span>
         </div>
         <div>
             <slot></slot>
         </div>
        
     </div>
</template>

<script>
export default {
    name: "table_nav",
    props: ["title","item",'itemColor']
}
</script>

<style lang="less">
.table_nav{
    box-sizing: border-box;
    height: 50px;
    background: #F6F6F8;
    display: flex; 
    padding: 0 14px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    width:910px;
    .table_name{
       span:nth-child(1){
            font-size: 16px;
            font-weight: bold ;
            color: #222222;
            margin-right:10px ;
        }
        span:nth-child(1)::before{
            display: inline-block;
            content: "";
            width: 6px;
            height: 14px;
            background: #E05C5C;
            margin-right:10px ;
        }
        span:nth-child(2){
            font-size: 14px;
            font-weight: 400;
        } 
    }
    
}
</style>